import { z } from "zod";

import { CommonModels } from "@/data/common/common.models";
import { AppRestClient } from "@/util/rest/clients/app-rest-client";

import { BizTagsModels } from "./bizTags.models";

export namespace BizTagsApi {
  export const listTags = (limit: number, order?: string, page?: number, cursor?: string, filterName?: string) => {
    return AppRestClient.get({ resSchema: BizTagsModels.ListTagsResponseSchema }, `/biz/tag/list`, {
      params: {
        order,
        limit,
        page,
        cursor,
        "filter[name]": filterName,
      },
    });
  };

  export const createTag = (data: BizTagsModels.CreateBizTagDto) => {
    return AppRestClient.post({ resSchema: CommonModels.BizTagDtoSchema }, `/biz/tag`, data);
  };

  export const deleteTag = (id: string) => {
    return AppRestClient.delete({ resSchema: z.void() }, `/biz/tag/${id}`);
  };

  export const updateTag = (id: string, data: BizTagsModels.UpdateBizTagDto) => {
    return AppRestClient.patch({ resSchema: CommonModels.BizTagDtoSchema }, `/biz/tag/${id}`, data);
  };
}
